var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { changeBetAmount as changeBetAmountAction, selectBetType as selectBetTypeAction } from '../../../actions/coupon/creators/coupon';
import { getResourceAmount, resourceNames } from '../../../constants/accountResourceNames';
import { SYSTEM, SINGLE } from '../../../constants/BetType';
import _Input from './_Input';
import StakeVariants from '../StakeVariants';
import { defineMessages, FormattedHTMLMessage, FormattedMessage, injectIntl } from 'react-intl';
import { cssClassMap } from '../../../constants/SportCssMap';
import { isRateUnavailable } from '../rateUtils';
import RenderBetItem from './RenderBetItem';
import * as BetStatus from '../../../constants/BetStatus';
import { disableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';
var messages = defineMessages({
    bets_potential_return: {
        id: 'bets.potential_return',
        defaultMessage: 'Возможный выигрыш:'
    },
    coupon_system: {
        id: 'coupon.system',
        defaultMessage: '{ rank }/{ count }'
    },
    coupon_bets_by: {
        id: 'coupon.bets_by',
        defaultMessage: 'Ставок: { possibleBets } по'
    },
    coupon_total_odd: {
        id: 'coupon.total_odd',
        defaultMessage: 'Общий коэффициент'
    },
    coupon_stake_amount: {
        id: 'coupon.stake_amount',
        defaultMessage: 'Сумма ставки'
    },
    total_bet_amount: {
        id: 'coupon.total_amount2',
        defaultMessage: 'Общая сумма ставки',
    },
});
var System = /** @class */ (function (_super) {
    __extends(System, _super);
    function System() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            selectedItemKey: 0
        };
        _this.targetElement = null;
        _this.changeAmount = function (e) {
            if (!_this.props.freebetToggled) {
                _this.props.changeBetAmountAction(e.target.value.replace(/\D/g, ''));
            }
        };
        _this.changeSystemVariant = function (rank) {
            _this.props.selectBetTypeAction({ 'betType': SYSTEM, rank: rank });
            _this.setState({
                selectedItemKey: rank
            });
        };
        _this.deleteBetSlip = function (id) {
            _this.props.deleteBetSlipAction(id);
        };
        _this.addBtnHandler = function (couponAmountValue, amount) {
            _this.props.changeBetAmountAction(+couponAmountValue + amount);
        };
        _this.subtractBtnHandler = function (couponAmountValue, amount) {
            if (+couponAmountValue >= amount) {
                _this.props.changeBetAmountAction(+couponAmountValue - amount);
            }
        };
        return _this;
    }
    System.prototype.componentDidMount = function () {
        this.targetElement = document.querySelector('#items');
        disableBodyScroll(this.targetElement, {
            allowTouchMove: function (el) {
                while (el && el !== document.body) {
                    if (el.getAttribute('bodyscrolllockignore') !== null) {
                        return true;
                    }
                    el = el.parentNode;
                }
            },
        });
    };
    System.prototype.componentWillUnmount = function () {
        clearAllBodyScrollLocks();
    };
    System.prototype.componentWillMount = function () {
        var systemVariants = this.props.systemVariants;
        var stakeVariant = systemVariants[0];
        if (stakeVariant !== undefined) {
            this.setState({
                selectedItemKey: systemVariants[0].rank
            });
            this.props.selectBetTypeAction({ 'betType': SYSTEM, rank: stakeVariant.rank });
        }
        else {
            this.props.selectBetTypeAction({ 'betType': SINGLE });
        }
    };
    System.prototype.renderBet = function (bet, couponAmount, index, languageId) {
        var disabled = isRateUnavailable(bet.get('rate'));
        var bettingState;
        if (bet.get('unavailable') === true) {
            disabled = true;
            bettingState = bet.get('bettingState');
        }
        var props = {
            match: bet.get('match'),
            outcome: bet.get('outcome'),
            rate: bet.get('rate'),
            deleteBetSlip: this.deleteBetSlip,
            prompt: this.props.prompt,
            betSlipsPromptClose: this.props.betSlipsPromptClose,
            disabled: disabled,
            languageId: languageId,
            bettingState: bettingState,
            currency: resourceNames[this.props.user.accountResourceId]
        };
        var itemCls = "item ".concat(cssClassMap[bet.get('rate').get('sportId')]);
        if (isRateUnavailable(bet.get('rate'))) {
            itemCls += ' disable';
        }
        return (_jsx("div", __assign({ className: itemCls }, { children: _jsx("div", __assign({ className: 'item-inner' }, { children: _jsx(RenderBetItem, __assign({}, props)) })) }), index));
    };
    System.prototype.renderItem = function (bet, index) {
        var _this = this;
        var selectedBetType = this.props.selectedBetType;
        var count = bet.count;
        var rank = bet.rank;
        var odd = bet.odd;
        return (_jsxs("div", __assign({ className: "system-variants__item ".concat(rank === selectedBetType.rank ? 'active' : ''), onClick: function () { return _this.changeSystemVariant(rank); } }, { children: [_jsx("label", { children: _jsx(FormattedHTMLMessage, __assign({}, messages.coupon_system, { values: { rank: rank, count: count } })) }), _jsx("div", __assign({ className: 'rate' }, { children: odd }))] }), index));
    };
    System.prototype.render = function () {
        var _this = this;
        var _a = this.props, couponAmount = _a.couponAmount, systemVariants = _a.systemVariants, betSlips = _a.betSlips, errorCode = _a.errorCode, intl = _a.intl, languageId = _a.languageId, freebetToggled = _a.freebetToggled, freebet = _a.freebet, status = _a.status, client = _a.client;
        var selectedItemKey = this.state.selectedItemKey;
        var isBigStake = status === BetStatus.STAKE_REQUEST;
        var renderBetSlip = [];
        systemVariants.map(function (bet, i) {
            renderBetSlip.push(_this.renderItem(bet, i));
        });
        var renderBets = [];
        betSlips.map(function (bet, i) {
            renderBets.push(_this.renderBet(bet, couponAmount, i, languageId));
        });
        var selectedItem = systemVariants.filter(function (item) { return item.rank === selectedItemKey; });
        var odd = 0;
        if (selectedItem.length > 0) {
            odd = selectedItem[0].rawOdd;
        }
        var currency = resourceNames[this.props.user.accountResourceId];
        var amount = getResourceAmount(this.props.user.accountResourceId, client.country);
        var couponAmountValue = freebetToggled ? freebet.amount : couponAmount;
        if (couponAmountValue !== '') {
            localStorage.setItem('couponAmountValue', couponAmountValue);
        }
        var getLocalStorage = Number(localStorage.getItem('couponAmountValue'));
        var savedCouponAmountValue = getLocalStorage > 0 ? getLocalStorage : '';
        var possibleWin = ((couponAmountValue || getLocalStorage) * odd);
        return (_jsxs(Fragment, { children: [_jsxs("div", __assign({ id: 'items' }, { children: [_jsx("div", __assign({ className: 'items system', bodyscrolllockignore: 'body-scroll-lock-ignore' }, { children: _jsx("div", __assign({ className: 'item' }, { children: renderBets })) })), _jsx("div", __assign({ className: 'system-variants', bodyscrolllockignore: 'body-scroll-lock-ignore' }, { children: renderBetSlip }))] })), _jsx("div", { id: 'items2' }), _jsxs("div", __assign({ className: 'add' }, { children: [_jsxs("span", __assign({ className: 'stake-label' }, { children: [_jsx(FormattedMessage, __assign({}, messages.bets_potential_return)), _jsxs("span", { children: [_jsx("span", __assign({ className: 'possible-win-amount' }, { children: possibleWin ? possibleWin.toFixed(2) : possibleWin })), " ", currency] })] })), _jsxs("div", __assign({ className: 'control' }, { children: [_jsxs("span", { children: [_jsx("button", { className: 'subtract-btn', onClick: function () { return _this.subtractBtnHandler(savedCouponAmountValue, amount); } }), _jsx(_Input, { changeAmount: this.changeAmount, freebetToggled: freebetToggled, couponAmount: savedCouponAmountValue, placeholder: intl.formatMessage(messages.coupon_stake_amount), error: errorCode }), _jsx("button", { className: 'add-btn', onClick: function () { return _this.addBtnHandler(savedCouponAmountValue, amount); } })] }), !isBigStake && this.props.showError] }))] })), _jsx(StakeVariants, { freebetToggled: freebetToggled })] }));
    };
    return System;
}(React.Component));
System.propTypes = {
    betTypes: PropTypes.object.isRequired,
    betSlips: PropTypes.object.isRequired,
    couponAmount: PropTypes.any.isRequired,
    selectedBetType: PropTypes.object.isRequired,
    selectBetTypeAction: PropTypes.func.isRequired,
    prompt: PropTypes.bool.isRequired,
    errorCode: PropTypes.number.isRequired,
    betSlipsPromptClose: PropTypes.func.isRequired,
    intl: PropTypes.object.isRequired,
    languageId: PropTypes.number.isRequired,
    showError: PropTypes.any.isRequired,
    freebetToggled: PropTypes.bool.isRequired,
    freebet: PropTypes.object.isRequired,
    balance: PropTypes.number.isRequired,
    user: PropTypes.object.isRequired,
    client: PropTypes.object.isRequired,
};
function mapStateToProps(state, props) {
    var betSlips = state.coupon.get('betSlips');
    var selectedBetType = props.selectedBetType;
    var betTypes = state.coupon.get('betTypes').filter(function (bt) { return bt.type !== 5; }); // Убрали Антиэкспресс что бы расчеты были правильными
    var balance = state.balance.value;
    var systemVariants = betTypes.filter(function (b) {
        return b.type === selectedBetType.betType;
    }).toArray();
    return {
        user: state.auth.user,
        betTypes: betTypes,
        betSlips: betSlips,
        systemVariants: systemVariants,
        state: state,
        balance: balance,
        languageId: state.application.get('languageId'),
        client: state.application.get('client'),
    };
}
var mapDispatchToProps = function (dispatch) { return bindActionCreators({
    changeBetAmountAction: changeBetAmountAction,
    selectBetTypeAction: selectBetTypeAction
}, dispatch); };
System = connect(mapStateToProps, mapDispatchToProps)(System);
export default injectIntl(System);



// WEBPACK FOOTER //
// ./src/components/coupon/betTypesComponents/System.jsx